export const RECOMMENDED_AMOUNT_VODS = 12

export const RECOMMENDED_AMOUNT_VODS_AND_CURRENT = RECOMMENDED_AMOUNT_VODS + 1
